import styled from 'styled-components';

import { Theme } from '../Theme';

export const Tabs = styled.div`
	display: flex;
	width: auto;
	gap: 1rem;
	border-bottom: 0.5px solid ${Theme.mediumGrey}
	padding: 0rem;
`;

export const Tab = styled.div`
	font-size: 14px;
	font-weight: ${(props) => (props.active ? '600' : '500')};
	opacity: ${(props) => (!props.active ? '20%' : null)};
	padding: 0.5rem 0;
	margin: 0;
	border-radius: 4px;
	border-bottom: ${(props) => (props.active ? `4px solid ${Theme.primary}` : null)};
	cursor: pointer;
`;
